import React, { useEffect, useState } from "react";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { getNotifications, markNotificationRead, markAllNotificationsRead } from "../../services/notificationService";

const Notifications = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    getNotifications()
      .then((data) => setItems(data.notifications || []))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleRead = async (n) => {
    if (!n.read_at) await markNotificationRead(n.id);
    if (n.url) window.location.href = n.url;
    else load();
  };

  return (
    <React.Fragment>
      <Header parentMenu="notifications" activeMenu="/notifications" />
      <SiteBreadcrumb pageTitle="Notifications" pageName="Notifications" breadcrumbsImg={bannerbg} />

      <section style={{ padding: "80px 0" }}>
        <div className="container" style={{ maxWidth: 700 }}>
          {!loading && items.length > 0 && (
            <div style={{ textAlign: "right", marginBottom: 16 }}>
              <button
                onClick={async () => {
                  await markAllNotificationsRead();
                  load();
                }}
                className="thm-btn"
                style={{ background: "#eee", color: "#333" }}
              >
                সব Read করুন
              </button>
            </div>
          )}

          {loading && <p>লোড হচ্ছে...</p>}
          {!loading && items.length === 0 && <p>কোনো notification নেই।</p>}

          {items.map((n) => (
            <button
              key={n.id}
              onClick={() => handleRead(n)}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                padding: "16px",
                marginBottom: 10,
                borderRadius: 8,
                border: "1px solid #eee",
                background: n.read_at ? "#fff" : "#fff7e6",
                cursor: "pointer",
              }}
            >
              <strong>{n.title}</strong>
              <p style={{ margin: "4px 0 0", color: "#666" }}>{n.message}</p>
            </button>
          ))}
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default Notifications;
